module.exports = __webpack_public_path__ + "img/404.375a4205.png";